export const disciplineLabel = {
  fontFamily: 'Open Sans',
  fontWeight: '400',
  lineHeight: '36px',
  fontSize: '24px',
  color: '#383838',
  width: '228px',
};
